<template>
  <div class="container hasBG challenges flexbox">
    <div class="competition_subject" v-if="dataReady && !showResult && questions.length > 0">
      <div class="backIndex" @click="$router.replace('/challenges/index')"><i class="iconfont iconfanhui1"></i>返回首页</div>
      <div class="title">
        <div class="header">
          <div class="subject_type">{{currentQuestion.questionmode}}</div>
          <div class="subject_num">{{currentIndex + 1}}/{{questions.length}}</div>
        </div>
        <div class="subject_title">{{currentQuestion.questionname}}</div>
      </div>
      <div class="option">
        <h4>答案选项</h4>
        <div class="option_item">
          <div
            class="option_list van-hairline--surround"
            v-for="option in currentQuestion.examquestionSelectorList"
            :key="option.id"
            :class="{
              'selected': answerSheet[currentIndex].answerselector.indexOf(option.selectorname) > -1,
              'right': currentQuestion.questiontype === 0 && answerSheet[currentIndex].answerselector === currentQuestion.rightanswer && checkAnswer,
              'error': currentQuestion.questiontype === 0 && answerSheet[currentIndex].answerselector != currentQuestion.rightanswer && checkAnswer
            }"
            @click="selectAnswer(option.selectorname, currentQuestion.id, currentQuestion.questiontype)"
          >
            <div
              class="van-hairline--surround"
              :class="{'option-checkbox': currentQuestion.questiontype, 'option-radio': !currentQuestion.questiontype}"
            >
              {{option.selectorname}}
            </div>
            <div class="option-content">{{option.content}}</div>
            <div class="right_error" v-show="checkAnswer && answerSheet[currentIndex].answerselector.indexOf(option.selectorname) > -1">
              <i class="iconfont iconicon-xuanzhong" v-show="currentQuestion.questiontype === 0 && answerSheet[currentIndex].answerselector === currentQuestion.rightanswer"></i>
              <i class="iconfont iconx" v-show="currentQuestion.questiontype === 0 && answerSheet[currentIndex].answerselector != currentQuestion.rightanswer"></i>
            </div>
          </div>
        </div>
        <div class="answerKeys">
          <div class="zqda" v-show="checkAnswer">正确答案：{{currentQuestion.rightanswer}}</div>
          <div class="subject_btn">
            <van-button v-show="currentIndex !== questions.length - 1 || !checkAnswer" @click="check(currentQuestion.questiontype)">{{!checkAnswer ? '继续' : '下一题'}}</van-button>
            <van-button v-show="currentIndex === questions.length - 1 && checkAnswer" @click="onSubmit">提交</van-button>
          </div>
          <!-- <p class="dajx">答案解析：</p> -->
          <!-- <div>{{currentQuestion.remark}}</div> -->
        </div>
<!--         <div class="subject_btn">
          <van-button v-show="currentIndex !== questions.length - 1 || !checkAnswer" @click="check(currentQuestion.questiontype)">{{!checkAnswer ? '继续' : '下一题'}}</van-button>
          <van-button v-show="currentIndex === questions.length - 1 && checkAnswer" @click="showResult = true">提交</van-button>
        </div> -->
      </div>
    </div>
    <div class="practiceResult" v-if="showResult">
      <div class="backIndex" @click="$router.replace('/challenges/index')"><i class="iconfont iconfanhui1"></i>返回首页</div>
      <div class="result_wrapper">
        <div class="result_header">
          <!-- <h5>{{$store.state.userinfo.name}}</h5> -->
          <p>恭喜你完成全部学习内容！</p>
        </div>
        <div class="result_content">
          <h3><i class="iconfont iconxingxing"></i>本次学习结果<i class="iconfont iconxingxing"></i></h3>
          <div class="score">{{score}}<span>分</span></div>
          <div class="btn_group challenges">
            <van-button @click="restart">重新学习</van-button>
            <van-button @click="$router.push({path: '/challenges/exam', query: {id: $route.query.id}})">正式答题</van-button>
          </div>
        </div>
      </div>
    </div>
    <p class="tips" v-if="dataReady">技术支持：广东科技报   广州市乾润信息技术有限公司</p>
    <div class="adv" @click="hrefTo">
      <img src="../../../assets/images/fuchuang.gif" alt="">
    </div>
    <div class="loading" v-if="!dataReady">
      <van-loading type="spinner" color="#1989fa" size="50px" />
    </div>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  import $ from 'jquery'
  const u = navigator.userAgent
  export default {
    name: 'challengesExamList',
    data () {
      return {
        questions: [],
        answerSheet: [],
        currentIndex: 0,
        dataReady: false,
        checkAnswer: false,
        score: 0,
        showResult: false,
        examname: ''
      }
    },
    computed: {
      currentQuestion: function() {
        // console.log(this.questions[this.currentIndex])
        return this.questions[this.currentIndex]
      }
    },
    created () {
      this.$toast.allowMultiple()
      this.$fetch.get(API.NATURELISTALLEXAMQUESTION, {
        examid: this.$route.query.id
      }).then(response => {
        // console.log(response)
        this.dataReady = true
        if (response.data.examQuestionList.length === 0) {
          this.$toast({
            message: '暂无题目',
            duration: 0
          })
          return
        }
        this.questions = response.data.examQuestionList
        this.examname = response.data.examname
        document.title = response.data.examname
        var _this = this
        this.questions.forEach(function(item){
          _this.answerSheet.push({
            id: item.id,
            answerselector: ''
          })
        })
      }).catch(error => {
        console.log(error)
      })
    },
    // mounted () {
    //   document.title = this.$store.state.title
    // },
    methods: {
      selectAnswer (value, id, multi) {
        if (!this.checkAnswer) {
          if (multi) {
            for (let answer of this.answerSheet) {
              if (answer.id === id) {
                let answerselector = answer.answerselector.length > 0 ? answer.answerselector.split(',') : []
                if (answer.answerselector.indexOf(value) > -1) {
                  answerselector.forEach((item, index) => {
                    if (item === value) answerselector.splice(index, 1)
                  })
                } else {
                  answerselector.push(value)
                }
                this.$set(answer, 'answerselector', answerselector.join(','))
              }
            }
          } else {
            for (let answer of this.answerSheet) {
              if (answer.id === id) {
                this.$set(answer, 'answerselector', value)
              }
            }
            if (this.answerSheet[this.currentIndex+1] && this.answerSheet[this.currentIndex+1].answerselector === '') {
              // setTimeout(() => {
              //   this.currentIndex = this.currentIndex + 1
              // }, 200)
            }
          }
        }
      },
      check (type) {
        if (this.checkAnswer) {
          this.checkAnswer = false
          if (this.currentIndex === this.questions.length-1) return
          this.currentIndex = this.currentIndex + 1
        } else {
          if (!this.answerSheet[this.currentIndex].answerselector) {
            this.$toast('请先选择你的答案')
          } else {
            if (type) {
              var answer = this.answerSheet[this.currentIndex].answerselector.split(',').sort()
              var rightanswer = this.currentQuestion.rightanswer.split('').sort()
              if (answer.join('') === rightanswer.join('')) {
                this.score += this.currentQuestion.score
              }
            } else {
              if (this.answerSheet[this.currentIndex].answerselector === this.currentQuestion.rightanswer) {
                this.score += this.currentQuestion.score
              }
            }
            // console.log(this.score)
            this.checkAnswer = true
          }
        }
      },
      restart () {
        var _this = this
        this.showResult = false
        this.dataReady = false
        this.currentIndex = 0
        this.score = 0
        this.checkAnswer = false
        this.answerSheet = []
        this.questions.forEach(function(item){
          _this.answerSheet.push({
            id: item.id,
            answerselector: ''
          })
        })
        document.title = this.examname
        this.dataReady = true
      },
      onSubmit () {
        document.title = '学习结果'
        this.showResult = true
      },
      hrefTo () {
        location.href = 'https://www.gdkjb.com/special/dasaiindex.html'
      }
    },
    beforeRouteLeave (to, from, next) {
      this.$dialog.close()
      this.$toast.clear()
      next()
    }
  }
</script>

<style lang="stylus">
.adv {
  animation: firstdiv 5s linear 1s infinite alternate;
}
@keyframes firstdiv{
  0%{bottom:90px;right:20px;}
  25%{bottom:90px;right:120px;}
  50%{bottom:200px;right:120px;}
  75%{bottom:200px;right:20px;}
  100%{bottom:90px;right:20px;}
}
</style>